module.exports = __webpack_public_path__ + "img/banner.c3e1cfc1.png";